import { API_SHIPPING } from "../../config";
import axios from "axios";

/**
 * 
 * @param {Object} user 
 * @param {string} user.firstName 
 * @param {string} user.lastName 
 * @param {string} user.email 
 * @param {string} user.phonePrefix 
 * @param {string} user.phone 
 * @param {string} user.password 
 * @param {string} [user.courierName] - only for open courier
 * @param {string} user.courierCode 
 * @param {string} user.courierType 
 */
export const signUp = async (user) => {
  const payload = {
    first_name: user.firstName,
    last_name: user.lastName,
    email: user.email,
    phone: user.phonePrefix + user.phone,
    password: user.password,
    courier_code: user.courierCode,
    courier_type: user.courierType,
    source: "courierApp",
  };

  if (user.courierName) payload.courier_name = user.courierName;

  const response = await axios.post(`${API_SHIPPING}/v1/signup`, payload);

  return response.data;
};

export const signIn = (user) => {
  return fetch(`${API_SHIPPING}/v1/signin`, {
    mode: "cors",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(user),
  })
    .then((response) => {
      return response.json();
    })
    .catch((error) => {
      console.log(error);
      return {
        success: false,
        error: "Gagal login"
      }
    });
};

export const authenticate = (data, next) => {
  if (typeof window !== "undefined") {
    localStorage.setItem("jwt", JSON.stringify(data));
    next();
  }
};

export const signOut = (next) => {
  if (typeof window !== "undefined") {
    localStorage.removeItem("jwt");
    next();
    return fetch(`${API_SHIPPING}/v1/signout`, {
      method: "GET",
    })
      .then((res) => {})
      .catch((err) => {
        console.log(err);
      });
  }
};

export const isAuthenticated = () => {
  if (typeof window == "undefined") {
    return false;
  }
  if (localStorage.getItem("jwt")) {
    return JSON.parse(localStorage.getItem("jwt"));
  } else {
    return false;
  }
};

export const isAdmin = () => {
  if (isAuthenticated().user.role === "admin") {
    return true;
  } else {
    return false;
  }
};
